<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- alert -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- alert end -->
    <!-- Title-->
    <header-component :headerTitle="headerText" />
    <!-- Title end -->
    <!-- popups -->
    <!-- filter data popup -->
    <v-dialog content-class="filter-repair" v-model="filterDetails" persistent max-width="1224px">
      <v-card class="filter_ui">
        <v-card-actions>
          <!--  fields -->
          <template v-if="active_tab == 'Create Grading Request'">
            <v-row>
              <v-col cols="6" sm="6" md="6" class="pr-0">
                <v-combobox v-model="article_id" :items="article_id_items" item-title="name" item-value="id" variant="outlined" color="primary" label="Article Id" class="ma-2" > </v-combobox>
              </v-col>
              <v-col cols="6" sm="6" md="6" class="pl-0">
                <v-combobox v-model="category" :items="category_items" item-title="name" item-value="id" variant="outlined" color="primary" label="Category"  class="ma-2" > </v-combobox>
              </v-col>
            </v-row>
          </template>
          <template v-if="active_tab == 'Grading Request Tracker'">
            <v-row>
              <v-col cols="6" sm="6" md="6" class="pr-0">
                <v-combobox v-model="assigned_executive" :items="assigned_executive_items" item-title="name" item-value="id" label="Assigned Executive" variant="outlined" color="primary" class="ma-2" > </v-combobox>
              </v-col>
              <v-col cols="6" sm="6" md="6" class="pr-0">
                <v-combobox v-model="status" :items="status_items" item-title="name" item-value="id" label="Status" variant="outlined" color="primary" class="ma-2" > </v-combobox>
              </v-col>
            </v-row>
          </template>
          <template v-if="active_tab == 'Pending Manual Disposition' || active_tab == 'Pending Approval'">
            <v-row>
              <v-col cols="4" sm="4" md="4" class="pr-0">
                <v-combobox v-model="previous_grade" :items="previous_grade_items" item-title="name" item-value="id" label="Previous Grade" variant="outlined" color="primary" class="ma-2" > </v-combobox>
              </v-col>
              <v-col cols="4" sm="4" md="4" class="pr-0">
                <v-combobox v-model="inward_grade" :items="inward_grade_items" item-title="name" item-value="id" label="Inward Grade" variant="outlined" color="primary" class="ma-2" > </v-combobox>
              </v-col>
              <v-col cols="4" sm="4" md="4" class="pr-0">
                <v-combobox v-model="previous_disposition" :items="previous_disposition_items" item-title="name" item-value="id" label="Previous Disposition" variant="outlined" color="primary" class="ma-2" > </v-combobox>
              </v-col>
            </v-row>
          </template>
        </v-card-actions>
        <v-card-actions class="margin-10">
          <v-spacer></v-spacer>
          <v-btn size="small"  class="text-none" variant="outlined" color="primary" @click="filterDetails = false" >Cancel</v-btn >
          <v-btn size="small"  class="text-none" variant="flat" color="primary" @click="applyFilterFun()">Appy Filter(S)</v-btn >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- create request popup -->
    <v-row justify="center">
      <v-dialog v-model="createRequestPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Create Request</span>
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="createRequestClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <v-combobox v-model="partner_assign" :items="partner_assign_items" item-title="name" item-value="id" return-object  label="Partner Assign"  variant="outlined" color="primary" class="ma-2" @update:modelValue="getExecutive"> </v-combobox>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-combobox v-model="executive_assign" :items="executive_assign_items" item-title="code" return-object label="Executive Assign"  variant="outlined" color="primary" class="ma-2" :disabled="isExecutiveAssignDisabled"> </v-combobox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <v-combobox v-model="type_of_request" :items="type_of_request_items" item-title="code" return-object label="Type of Request" disabled variant="outlined" color="primary" class="ma-2" > </v-combobox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
              <v-btn size="small" variant="flat" color="primary" class="mb-3 text-none" :disabled="!partner_assign || !executive_assign" @click="RequestSubmit">Submit</v-btn>
              <v-btn size="small" variant="outlined" color="primary" class="cancel-color mb-3 text-none" @click="createRequestClose">Cancel</v-btn>   
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- change assignee popup -->
    <v-row justify="center">
      <v-dialog v-model="changeAssigneePopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Change Assignee</span>
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="changeAssigneePopupClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="5" md="6">
                  <v-combobox v-model="executive_assignee" :items="executive_items_assignee" item-title="name" return-object  label="Partner Assign"  variant="outlined" color="primary" class="ma-2" @update:modelValue="changeExecutive"> </v-combobox>
                </v-col>
                <v-col cols="12" sm="5" md="6">
                  <v-combobox v-model="requestType_assignee" :items="requestType_items_assignee" item-title="code" return-object label="Executive Assign" variant="outlined" color="primary" class="ma-2" > </v-combobox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="5" md="6">
                  <v-combobox v-model="location_assignee" :items="location_items_assignee" item-title="code" return-object label="Type of Request" disabled variant="outlined" color="primary" class="ma-2" > </v-combobox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
              <v-btn size="small" variant="flat" color="primary" class="mb-3 text-none" :disabled="!executive_assignee" @click="ChangeAssigneeSubmit">Submit</v-btn>
              <v-btn size="small" variant="outlined" color="primary" class="cancel-color mb-3 text-none" @click="changeAssigneePopupClose">Cancel</v-btn>   
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- delete popup -->
    <v-row justify="center">
      <v-dialog v-model="deletePopup" persistent max-width="500px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="deletePopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text>
            <v-container>
              <p class="warningText">Are you sure you want to delete this request?</p>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" size="small" color="primary" class="mb-3 text-none" @click="confirmDelete">Yes</v-btn>
            <v-btn variant="flat" size="small" color="primary" class="cancel-color mb-3 text-none" @click="deletePopup = false">No</v-btn>   
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- item Details Popup -->
    <v-row justify="center">
      <v-dialog v-model="itemDetailsPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Tag ID " {{ itemInformation.tag_id }} "</span>
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="itemDetailsPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <span style="font-weight: 500;">Article ID</span>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  {{ itemInformation.article_id ? itemInformation.article_id : 'N/A' }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <span style="font-weight: 500;">Article Description</span>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  {{ itemInformation.article_description ? itemInformation.article_description : 'N/A' }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <span style="font-weight: 500;">Category</span>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  {{ itemInformation.category ? itemInformation.category : 'N/A' }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <span style="font-weight: 500;">Customer Name</span>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  {{ itemInformation.client_name ? itemInformation.client_name : 'N/A' }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <span style="font-weight: 500;">Customer Number</span>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  {{ itemInformation.client_contact_number ? itemInformation.client_contact_number : 'N/A' }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <span style="font-weight: 500;">Testing Location</span>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  {{ itemInformation.testing_location ? itemInformation.testing_location : 'N/A' }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <span style="font-weight: 500;">Serial Number 1</span>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  {{ itemInformation.serial_number_1 ? itemInformation.serial_number_1 : 'N/A' }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <span style="font-weight: 500;">Serial Number 2</span>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  {{ itemInformation.serial_number_2 ? itemInformation.serial_number_2 : 'N/A' }}
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Grading request tracker item Details Popup -->
    <v-row justify="center">
      <v-dialog v-model="gradingItemDetailsPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card class="v-card-100">
            <v-card-title class="d-flex">
              <v-row class="ma-1 mt-0">
              <span>Grading Request ID " {{ itemInformation.grading_request_id }} "</span>
              <v-spacer></v-spacer>
              <!-- <v-btn icon @click="gradingItemDetailsPopup = false"> -->
                <v-icon @click="gradingItemDetailsPopup = false">mdi-close</v-icon>
              <!-- </v-btn> -->
            </v-row>
            </v-card-title>
          </v-card>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <span style="font-weight: 500;">Sub Request ID</span>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  {{ itemInformation.sub_request_ids ? itemInformation.sub_request_ids.join(',  ') : 'N/A' }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <span style="font-weight: 500;">Tag ID(s)</span>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  {{ itemInformation.tag_ids ? itemInformation.tag_ids.join(',  ') : 'N/A' }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <span style="font-weight: 500;">Request Type</span>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  {{ itemInformation.request_type ? itemInformation.request_type : 'N/A' }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <span style="font-weight: 500;">Item Location</span>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  {{ itemInformation.item_location ? itemInformation.item_location : 'N/A' }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <span style="font-weight: 500;">Assigned Grading Executive</span>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  {{ itemInformation.assigned_executive ? itemInformation.assigned_executive : 'N/A' }}
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
        <v-dialog v-model="toBeDisposition" persistent max-width="424px">
          <v-card class="v-card-100 pa-2">
            <v-card-title style="padding: 0px 0px 32px;" class="d-flex align-center">
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="toBeDisposition = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="2" class="border-opacity-25 m-0"/>
            <v-card-text class="text-center">
              <span> Are you sure want to move this item to {{ itemDisposition.code }} ? </span>
            </v-card-text>
            <v-card-actions center class="mt-2">
              <v-spacer></v-spacer>
              <v-btn variant="outlined" color="primary" class="cancel-color mb-3 text-none" @click="toBeDisposition = false">Cancel</v-btn>   
              <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="confirmDisposition()">Confirm</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    <!-- success popup -->
    <v-row justify="center">
      <v-dialog v-model="successPopup" persistent max-width="500px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="closeSuccessPopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text>
            <v-container>
              <p class="text-center">{{ message }}</p>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" color="primary" class="mb-3 text-none" @click="closeSuccessPopup">Ok</v-btn>   
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- popups end -->
    <!-- Tabs -->
    <v-card class="v-card-100 mt-6">
      <v-tabs v-model="tab_index">
        <v-tab @click="loadData(tab, 'tab_clicked')" style="text-transform:none!important;text-decoration: none;" class="tab-color" v-for="(tab, index) in tabs" :key="index" >
          {{tab}}
        </v-tab>
      </v-tabs>
    </v-card>
    <!-- tabs end -->
    <!-- Search, Action Buttons, Filter -->
    <v-card-title style="padding: 28px" class="action-style pb-2">
      <!-- Search Fields -->
      <v-row>
        <!-- <v-col cols="4" sm="4"> -->
          <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" v-no-edge-space label="Search" class="search_style ma-2" variant="outlined" color="primary" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
        <!-- </v-col> -->
        <v-spacer></v-spacer>
        <!-- Action Buttons -->
        <!-- <v-col cols="3" sm="3" class="p-0"> -->
          <v-card-actions v-if="active_tab == 'Create Grading Request' && isActionAllowed(role)" class="pr-2" style="margin-top:-18px;">
            <v-btn class="text-none" style="min-height: 56px;" variant="flat" color="primary" :disabled="(this.selected.length == 0)" @click="createGradeRequest">Create Request</v-btn>
            <v-autocomplete v-model="disposition_source" :items="disposition_source_items" item-title="name" item-value="id" label="Source Disposition" variant="outlined" color="primary" class="mx-2 mt-5" @update:modelValue="gradingRequest()" > </v-autocomplete>
          </v-card-actions>
          <v-card-actions v-if="active_tab == 'Grading Request Tracker' && isActionAllowed(role)" class="pr-2" style="margin-top:-18px;">
            <v-btn class="text-none" variant="flat" style="min-height: 56px;" :disabled="(this.selected.length == 0)" color="primary" @click="changeAssignee">Change Assignee</v-btn>
            <v-btn class="text-none" variant="flat" style="min-height: 56px;" :disabled="(this.selected.length == 0)" color="primary" @click="DeleteItem">Delete</v-btn>
          </v-card-actions>
          <v-card-actions v-if="active_tab == 'Pending Manual Disposition' && isActionAllowed(role)" class="pr-2" style="margin-top:-18px;">
            <v-menu offset-y>
              <template v-slot:activator="{ props }">
                <v-btn color="primary" variant="flat" v-bind="props" style="min-height: 56px;" class="text-none"  :disabled="selected.length == 0">
                  Change Disposition
                  <v-icon dark :color="selected.length == 0 ? 'grey' : 'white'"> mdi-menu-down </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in change_disposition_list" :key="index" @click="changeDisposition(item)">
                  <v-list-item-title>{{ item.code }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-actions>
          <v-card-actions v-if="active_tab == 'Pending Approval' && isActionAllowed(role)" class="pr-2" style="margin-top:-18px;">
            <v-btn :disabled="(this.selected.length == 0)" class="text-none" variant="flat"  style="color:white;background-color: green; min-height: 56px;" color="green" @click="approve()">Approve</v-btn>
            <v-btn :disabled="(this.selected.length == 0)" class="text-none" variant="flat"  style="color:white;background-color: green; min-height: 56px;" color="red"  @click="reject()">Reject</v-btn>
          </v-card-actions>
        <!-- </v-col> -->
        <!-- Filter -->
          <v-expansion-panels class="custom-control_outlined  m-0 pt-2" ref="filterPopupRef" readonly
            style="max-width: 300px; margin-bottom: 28px; height: 56px;">
            <v-expansion-panel variant="outlined" @click="filterListOfButtons">
              <v-expansion-panel-title>Filter
              </v-expansion-panel-title>
            </v-expansion-panel>
          </v-expansion-panels>
      </v-row>
    </v-card-title>

    <!-- Data Table -->
    <v-layout column>
      <v-col cols="12" style="overflow: auto" class="p-0">
        <v-data-table hover
          density="compact"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :loading="loading"
          fixed-header
          height="100%"
          :items-per-page="pageSize"
          return-object
          loading-text="Loading Data... Please wait" class="elevation-1">
          <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
              <span v-if="header.key == 'tag_id'">
                <a href="#" @click.prevent="itemDetailPopup(item)" style="color: #1976d2 !important; cursor: pointer !important;"><u> {{ item.tag_id }}</u></a>
              </span> 
              <span v-else-if="header.key == 'grading_request_id'">
                <a href="#" @click.prevent="gradingItemDetailPopup(item)" style="color: #1976d2 !important; cursor: pointer !important;"><u> {{ item.grading_request_id }}</u></a>
              </span> 
              <span v-else-if="header.key == 'assigned_date'">
                {{ item.assigned_date.split('-').reverse().join('/') }}
              </span> 
              <span v-else-if="header.key !== 'tag_number' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else>-</span>
            </template>

          <!-- <template #[`item.tag_id`]="{ item }" v-if="active_tab == 'Create Grading Request'">
            <a @click="itemDetailPopup(item)" style="color: #1976d2;" class="cursor-pointer">
              <u> {{ item.tag_id }}</u>
            </a>
          </template> -->
          <!-- <template #[`item.grading_request_id`]="{ item }" v-if="active_tab == 'Grading Request Tracker'">
            <a @click="gradingItemDetailPopup(item)" style="color: #1976d2;">
              <u> {{ item.grading_request_id }}</u>
            </a>
          </template>
          <template #[`item.assigned_date`]="{ item }">
            {{ item.assigned_date.split('-').reverse().join('/') }}
          </template> -->
          <!-- <template #[`item.sending_location`]="{ item }" v-if="active_tab == 'Pending Manual Disposition' || active_tab == 'Pending Approval'">
            <span>{{ item.sending_location ? item.sending_location : "N/A" }}</span>
          </template>
          <template #[`item.receiving_loaction`]="{ item }" v-if="active_tab == 'Pending Manual Disposition' || active_tab == 'Pending Approval'">
            <span>{{ item.receiving_loaction ? item.receiving_loaction : "N/A" }}</span>
          </template>
          <template #[`item.previous_grade`]="{ item }" v-if="active_tab == 'Pending Manual Disposition' || active_tab == 'Pending Approval'">
            <span>{{ item.previous_grade ? item.previous_grade : "N/A" }}</span>
          </template>
          <template #[`item.inward_grade`]="{ item }" v-if="active_tab == 'Pending Manual Disposition' || active_tab == 'Pending Approval'">
            <span>{{ item.inward_grade ? item.inward_grade : "N/A" }}</span>
          </template> -->
          <template #bottom></template>
        </v-data-table> 
      </v-col>
    </v-layout>
    <!-- pagination display -->
    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
  </v-card>
</template>
<script>
   import HeaderComponent from "../../../commoncomponents/HeaderComponent.vue";
   import { moduleAccessFunc,module_that_allowed,signout,isOnlyViewAction } from '@/backend/axios/moduleAccess'
   import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
  // import { moduleAccessFunc,module_that_allowed,signout } from '@/backend/axios/moduleAccess';

  export default {
    components:{
      HeaderComponent,
    },
    data(){
      return{
        headerText:"Grading",
        tabs:[
            "Create Grading Request",
            "Grading Request Tracker",
            "Pending Manual Disposition",
            "Pending Approval"
        ],
        active_tab:"Create Grading Request",
        selected:[],
        table_data: [],
        headers:[
          { title: "Tag ID", align: "start", sortable: false, key:"request_id"},
          { title: "Article ID", key: "created_at" },
          { title: "Article Description", key: "status" },
          { title: "Category", key: "assignees_hash" },
          { title: "Item location", key: "assignees_hash" },
        ],
        alert: false,
        alert_type:"success",
        alert_message:'',
        search_tag:'',
        search:'',
        loading: true,
        filterDetails:false,
        article_id: null,
        article_id_items: [],
        category : null,
        category_items : [],
        page : 1 ,
        totalPages : 1,
        totalCount : '',
        pageSize: defaultPageSize,
        pageSizes: defaultPageSizes,
        createRequestPopup: false,
        changeAssigneePopup: false,
        deletePopup: false,
        partner_assign: null,
        partner_assign_items:[],
        executive_assign: null,
        executive_assign_items:[],
        type_of_request:'',
        type_of_request_items: [
          {
            "name":"Post-Repair",
            "id": "Post-Repair"
          },
        ],
        movement:[],
        movement_items:'',
        executive_assignee : '',
        executive_items_assignee:[],
        requestType_assignee:[],
        requestType_items_assignee:[],
        location_assignee:'Post-Repair',
        location_items_assignee:[
          {
            "name":"Post-Repair",
            "id": "Post-Repair"
          },
        ],
        movement_assignee:[],
        movement_items_assignee:'',
        successPopup: false,
        message: '',
        disposition_source : '',
        disposition_source_items : [],
        itemDetailsPopup : false,
        gradingItemDetailsPopup : false,
        change_disposition_list: [],
        toBeDisposition: false,
        itemDisposition: '',
        itemInformation: '',
        previous_grade : null,
        previous_grade_items : [],
        inward_grade : null,
        inward_grade_items : [],
        previous_disposition : null,
        previous_disposition_items : [],
        assigned_partner : '',
        assigned_partner_items : [],
        assigned_executive : null,
        assigned_executive_items : [],
        status : null,
        status_items : [],
        tab_index : 0,
        organization_name:'',
        dc_id:'',
      }
    },
    async created(){
      this.role = this.$store.state.currentUser.roles[0]
      if(this.role in module_that_allowed && moduleAccessFunc(this.role,'Grading')){
        signout()
        return;
      }
      this.disposition_source = 'Liquidation'
      const tab = this.$store.state.active_tab
      if(tab == 'Pending Approval'){
        this.tab_index = 3;
        this.loadData('Pending Approval');
      } else if(tab == 'Pending Manual Disposition'){
        this.tab_index = 2;
        this.loadData('Pending Manual Disposition');
      } else if(tab == 'Grading Request Tracker'){
        this.tab_index = 1;
        this.loadData('Grading Request Tracker');
      } else {
        this.tab_index = 0;
        this.loadData('Create Grading Request');
      }
      this.scrollToTop();
    },
    watch: {
      selected(newVal) {
        if (this.active_tab === 'Create Grading Request') {
          const putawayInward = newVal.filter(insurances => insurances.is_putaway_inwarded === false)
          const isUnderPhysicalInspection = newVal.filter((insurances) => insurances.is_under_physical_inspection === true);
          if (putawayInward.length > 0) {            
            this.$nextTick(() => {
              this.showAlert("warning", "Please complete Putaway Process");
              this.selected = [];
            });
          }else if(isUnderPhysicalInspection.length > 0){
            this.$nextTick(() => {
              this.showAlert("warning", "Action on item blocked as it is under cycle count process");
              this.selected = [];
            });
          }
        }
      },
    },
    computed: {
      isExecutiveAssignDisabled() {
        return this.partner_assign === null || this.partner_assign.length === 0;
      }
    },
    methods:{
      isActionAllowed(){
        return !isOnlyViewAction(this.role, 'Grading')
      },
      loadData(tab, tab_action){
        if (tab_action) {
          this.search_tag = ''
          this.disposition_source = 'Liquidation'
          this.$store.commit('setActiveTab',{ 'active_tab' : tab});
        }
        this.loading = true
        this.selected = []
        this.active_tab = tab
        this.table_data = []
        this.page = 1
        this.totalPages = 1
        if(tab == 'Create Grading Request'){
          (this.headers = [
            { title: "Tag ID", align: "start", sortable: false, key:"tag_id",minWidth:"120px"},
            { title: "Article ID", key: "article_id",minWidth:"160px" },
            { title: "Article Description", key: "article_description",minWidth:"250px" },
            { title: "Category", key: "category" },
            { title: "Customer Name", key: "client_name",minWidth:"200px" },
            { title: "Testing Location", key: "testing_location",minWidth:"200px" },
          ]);
          this.gradingRequest();
          this.disposition_source = 'Liquidation'
          this.getSourceDisposition();
        }
        if(tab == 'Grading Request Tracker'){
          (this.headers = [
            { title: "Grading Request ID", align: "start", sortable: false, key:"grading_request_id",minWidth:"250px"},
            { title: "Assigned Partner", key: "assigned_partner",minWidth:"200px" },
            { title: "Assigned Executive", key: "assigned_executive",minWidth:"250px" },
            { title: "Assigned Date", key: "assigned_date",minWidth:"200px" },
            { title: "Assigned Time", key: "assigned_time",minWidth:"200px" },
            { title: "Status", key: "status" },
          ]);
          this.gradingTracker();
        }
        if(tab == 'Pending Manual Disposition'){
          (this.headers = [
            { title: "Tag ID", align: "start", sortable: false, key:"tag_id",minWidth:"120px"},
            { title: "Article ID", key: "article_id",minWidth:"160px" },
            { title: "Article Description", key: "article_description",minWidth:"250px" },
            { title: "Sending Location", key:"sending_location",minWidth:"200px"},
            { title: "Receiving Location", key: "receiving_loaction",minWidth:"200px" },
            { title: "Previous Grade", key: "previous_grade",minWidth:"200px" },
            { title: "Inward Grade", key:"inward_grade",minWidth:"200px"},
            { title: "Previous Disposition", key: "source_module",minWidth:"250px" },
          ]);
          this.pendingManual();
          this.getDisposition();
        } if(tab == 'Pending Approval'){
          (this.headers = [
            { title: "Tag ID", align: "start", sortable: false, key:"tag_id",minWidth:"120px"},
            { title: "Article ID", key: "article_id",minWidth:"160px" },
            { title: "Article Description", key: "article_description",minWidth:"250px" },
            { title: "Sending Location", key:"sending_location",minWidth:"200px"},
            { title: "Receiving Location", key: "receiving_loaction",minWidth:"250px" },
            { title: "Previous Grade", key: "previous_grade",minWidth:"200px" },
            { title: "Inward Grade", key:"inward_grade",minWidth:"200px"},
            { title: "Previous Disposition", key: "source_module",minWidth:"250px" },
            { title: "Suggested Disposition", key: "suggested_disposition",minWidth:"250px" },
          ]);
          this.getPendingApproval();
        } 
      },
      gradingRequest(){
        // this.selected = [];
        const requestBody = {
          source_disposition: this.disposition_source,
          search_text: this.search_tag, 
          page: this.page, 
          per_page: this.pageSize,
        }
        this.loading = true
        this.$httpSecured
          .post('/api/v2/warehouse/grading/create_grading_request',requestBody)
          .then(response => {
            if (response.data) {
              this.table_data = response.data.grading_items;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.updateFilterItems();
              this.makeLoadingFalse();

            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      gradingTracker(){
        const params = this.getRequestParams( this.page, this.pageSize );
        this.$httpSecured
          .get('/api/v2/warehouse/grading/grading_request_tracker',{
            params :{ 
                search_text: this.search_tag, 
                page: params['page'], 
                per_page: params['size'],
              }
            })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.grading_requests;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.updateFilterItems();
              this.makeLoadingFalse();
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      pendingManual(){
        const params = this.getRequestParams( this.page, this.pageSize );
        this.$httpSecured
          .get('/api/v2/warehouse/grading/pending_manual_disposition',{
            params :{ 
                search_text: this.search_tag, 
                page: params['page'], 
                per_page: params['size'],
              }
            })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.grading_items;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.updateFilterItems();
              this.makeLoadingFalse();
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      getPendingApproval(){
        const params = this.getRequestParams( this.page, this.pageSize );
        this.$httpSecured
          .get('/api/v2/warehouse/grading/pending_approval',{
            params :{ 
                search_text: this.search_tag, 
                page: params['page'], 
                per_page: params['size'],
              }
            })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.grading_items;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.updateFilterItems();
              this.makeLoadingFalse();
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      // get field data & open popups
      getSourceDisposition(){
        this.$httpSecured
          .get('/api/v2/warehouse/grading/create_grading_request/get_source_disposition')
          .then(response => {
            if (response.data) {
              this.disposition_source_items = response.data;
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      createGradeRequest(){
        this.createRequestPopup = true;
        this.type_of_request = (this.disposition_source == 'Liquidation') ? 'Pre-Liquidation' : (this.disposition_source == 'Repair') ? 'Post-Repair' : 
        (this.disposition_source == 'Dispatch') ? 'Pre-Dispatch' : (this.disposition_source == 'Return Creation') ? 'Pre-Inward' :  'Inward';
        this.partner_assign = '';
        this.executive_assign = '';
        // this.type_of_request = '';
        this.$httpSecured
        .get('/api/v2/warehouse/grading/create_grading_request/get_partners')
        .then(response => {
          const partner = response.data.partners_name;
          this.partner_assign_items = partner ? [partner] : [];
          this.partner_assign = this.partner_assign_items[0] || '';
          this.getExecutive();
        })
        .catch(error => {
          console.error("Error fetching disposition data:", error);
        });
      },
      getExecutive(){
        var dc = this.selected.map(x => x.distribution_center_id)
        const unique = (value, index, self) => {
          return self.indexOf(value) === index
        }
        dc = dc.filter(function (element) {
          return element !== undefined;
        });
        var unique_array = dc.filter(unique)
        var dato = unique_array[0];
        this.dc_id = dato.toString()
        const params = { 
          id : this.partner_assign.id,
          distribution_center_id: this.dc_id
           }
        this.$httpSecured
          .get('/api/v2/warehouse/grading/create_grading_request/get_executives',{params : params} )
          .then(response => {
            this.executive_assign_items = response.data.executives_name.sort((a, b) => {
              if (/^\d/.test(a) && /^\d/.test(b)) {
                return a.localeCompare(b);
              }
              else if (/^\d/.test(a)) {
                return 1;
              } else if (/^\d/.test(b)) {
                return -1;
              }
              else {
                return a.localeCompare(b);
              }
            });
          })
          .catch(error => {
            console.error("Error fetching brand data:", error);
          });
      },
      changeAssignee(){
        this.changeAssigneePopup = true;
        var dc = this.selected.map(x => x.distribution_center_id)
        const unique = (value, index, self) => {
          return self.indexOf(value) === index
        }
        dc = dc.filter(function (element) {
          return element !== undefined;
        });
        var unique_array = dc.filter(unique)
        var dato = unique_array[0];
        this.dc_id = dato.toString()
        const params = {
          distribution_center_id: this.dc_id
           }
        this.executive_assignee = this.selected.map(item => item.assigned_partner);
        this.requestType_assignee = this.selected.map(item => item.assigned_executive);
        this.location_assignee = this.selected.map(item => item.request_type);
        this.$httpSecured
          .get('/api/v2/warehouse/grading/create_grading_request/get_partners')
          .then(response => {
            this.executive_items_assignee = response.data.partners_name;
          })
          .catch(error => {
            console.error("Error fetching disposition data:", error);
          });
          this.$httpSecured
          .get('/api/v2/warehouse/grading/create_grading_request/get_executives',{params : params})
          .then(response => {
            // this.requestType_items_assignee = response.data.executives_name
            this.requestType_items_assignee = response.data.executives_name.sort((a, b) => {
              if (/^\d/.test(a) && /^\d/.test(b)) {
                return a.localeCompare(b);
              }
              else if (/^\d/.test(a)) {
                return 1;
              } else if (/^\d/.test(b)) {
                return -1;
              }
              else {
                return a.localeCompare(b);
              }
            });
          })
          .catch(error => {
            console.error("Error fetching brand data:", error);
          });
      },
      changeExecutive(){
        var dc = this.selected.map(x => x.distribution_center_id)
        const unique = (value, index, self) => {
          return self.indexOf(value) === index
        }
        dc = dc.filter(function (element) {
          return element !== undefined;
        });
        var unique_array = dc.filter(unique)
        var dato = unique_array[0];
        this.dc_id = dato.toString()
        const params = { 
          id : this.executive_assignee.id,
          distribution_center_id: this.dc_id
           }
        this.$httpSecured
          .get('/api/v2/warehouse/grading/create_grading_request/get_executives',{params : params} )
          .then(response => {
            this.requestType_items_assignee = response.data.executives_name;
          })
          .catch(error => {
            console.error("Error fetching brand data:", error);
          });
      },
      DeleteItem(){
        this.deletePopup = true
      },
      confirmDelete(){
        const itemid = this.selected.map(item => item.id)
        const requestBody = {
          ids : itemid,
        }
        this.$httpSecured.post("/api/v2/warehouse/grading/grading_request_tracker/delete_request", requestBody)
        .then(response => {
          if (response.data) {
              this.deletePopup = false;
              this.successPopup = true;
              this.message = response.data.message;
              this.deletePopup = false;
            }else{
            this.ErroeMsg = response.data.error;
          }
        })
        .catch(error =>{
          this.number=0;
          this.$toast.error(error.response.data.error)
        }) 
      },
      getDisposition() {
        this.$httpSecured
          .get("/api/v2/warehouse/grading/pending_manual_disposition/get_dispositions")
          .then(response => {
            if (response.data) {
              this.change_disposition_list = response.data.dispositions

            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", error.response.data.error);
            this.loading = false;
          });
      },
      changeDisposition(item){
        this.toBeDisposition = true;
        this.itemDisposition = item;
      },
      confirmDisposition(){
        const dispoItem = this.itemDisposition.id
        const itemid = this.selected.map(item => item.id)
        const requestBody = {
          ids : itemid,
          disposition : dispoItem
        }
        this.$httpSecured.post("/api/v2/warehouse/grading/pending_manual_disposition/change_disposition", requestBody)
        .then(response => {
          if (response.data) {
              this.successPopup = true;
              this.message = response.data.message;
            }else{
            this.ErroeMsg = response.data.error;
          }
        })
        .catch(error =>{
          this.number=0;
          this.$toast.error(error.response.data.error)
        }) 
      },
      closeSuccessPopup(){
        this.deletePopup = false;
        this.successPopup = false;
        this.changeAssigneePopup = false;
        this.createRequestPopup = false;
        this.toBeDisposition = false;
        this.selected = ''
        this.loadData(this.active_tab);
      },
      itemDetailPopup(item){
        this.itemDetailsPopup = true
        this.itemInformation = item

      },
      gradingItemDetailPopup(item){
        this.gradingItemDetailsPopup = true;
        this.itemInformation = item;
      },
      // closing popup function
      createRequestClose(){
        this.createRequestPopup = false;
        this.partner_assign = '';
        this.executive_assign = '';
        this.type_of_request = ''; 
        this.movement = '';
      },
      changeAssigneePopupClose(){
        this.changeAssigneePopup = false;
        this.partner_assign_assignee = '';
        this.requestType_assignee = '';
        this.location_assignee = '';
        this.movement_assignee = '';
      },
      // submit function
      RequestSubmit(){
        const itemid = this.selected.map(item => item.id)
        this.type_of_request = (this.disposition_source == 'Liquidation') ? 'Pre-Liquidation' : (this.disposition_source == 'Repair') ? 'Post-Repair' : 
        (this.disposition_source == 'Dispatch') ? 'Pre-Dispatch' : (this.disposition_source == 'Return Creation') ? 'Pre-Inward' :  'Inward';
        const requestBody = {
          ids : itemid,
          partner: this.partner_assign.name,
          executive: this.executive_assign,
          request_type: this.type_of_request
        }
        this.$httpSecured.post("/api/v2/warehouse/grading/create_grading_request/create_request", requestBody)
        .then(response => {
          if (response.data) {
              this.successPopup = true;
              this.message = response.data.message;
              this.executive = '';
              this.executive_assign = '';
              this.type_of_request = ''; 
              this.movement = '';
            }else{
            this.ErroeMsg = response.data.error;
          }
        })
        .catch(error =>{
          this.number=0;
          this.$toast.error(error.response.data.error)
        }) 
      },
      // change assignee
      ChangeAssigneeSubmit() {
        const itemIds = this.selected.map(item => item.id);
        let locationAssigneeValue = Array.isArray(this.location_assignee) ? this.location_assignee[0] : this.location_assignee;
        let partnerValue;
        if (Array.isArray(this.executive_assignee)) {
           partnerValue = this.executive_assignee[0];
        } else if (typeof this.executive_assignee === 'object' && this.executive_assignee !== null) {
            partnerValue = this.executive_assignee.name;
        } else {
            partnerValue = this.executive_assignee;
        }
        let requestType_assignee = Array.isArray(this.requestType_assignee) ? this.requestType_assignee[0] : this.requestType_assignee;
        const requestBody = {
          ids: itemIds,
          partner: partnerValue,
          executive: this.requestType_assignee,
          request_type: locationAssigneeValue
        };

        this.$httpSecured.post("/api/v2/warehouse/grading/grading_request_tracker/change_assignee", requestBody)
          .then(response => {
            if (response.data) {
              this.successPopup = true;
              this.message = response.data.message;
              this.executive_assignee = '';
              this.requestType_assignee = '';
              this.location_assignee = '';
            } else {
                this.ErrorMsg = response.data.error;
            }
          })
          .catch(error => {
            this.number = 0;
            this.$toast.error(error.response.data.error);
          });
      },
      approve(){
        const itemIds = this.selected.map(item => item.id);
        const requestBody = {
          ids: itemIds,
        };
        this.$httpSecured.post("/api/v2/warehouse/grading/pending_approval/approve_request", requestBody)
          .then(response => {
            if (response.data) {
              this.successPopup = true;
              this.message = response.data.message;
            } else {
                this.ErrorMsg = response.data.error;
            }
          })
          .catch(error => {
            this.number = 0;
            this.$toast.error(error.response.data.error);
          });
      },
      reject(){
        const itemIds = this.selected.map(item => item.id);
        const requestBody = {
          ids: itemIds,
        };
        this.$httpSecured.post("/api/v2/warehouse/grading/pending_approval/reject_request", requestBody)
          .then(response => {
            if (response.data) {
              this.successPopup = true;
              this.message = response.data.message;
            } else {
                this.ErrorMsg = response.data.error;
            }
          })
          .catch(error => {
            this.number = 0;
            this.$toast.error(error.response.data.error);
          });
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
      // filter function
      filterListOfButtons() {
        document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 20).toString() + 'px');
        this.filterDetails = true;
        this.category = null;
        this.status = null;
        this.assigned_partner = '';
        this.assigned_executive = null;
        this.previous_grade = null;
        this.inward_grade = null;
        this.previous_disposition = null;
        this.article_id = null;
        this.$httpSecured
          .get("/api/v2/warehouse/grading/create_grading_request/get_filter_categories")
          .then(response => {
            if (response.data) {
              this.category_items = response.data.categories
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          this.$httpSecured
          .get("/api/v2/warehouse/grading/create_grading_request/get_partners")
          .then(response => {
            if (response.data) {
              
              this.assigned_partner_items = response.data.partners_name
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          this.$httpSecured
          .get("/api/v2/warehouse/grading/create_grading_request/get_executives")
          .then(response => {
            if (response.data) {
              this.assigned_executive_items = response.data.executives_name
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
      },
      applyFilterFun(){
        if (this.active_tab == 'Create Grading Request'){
          const requestBody = {
            source_disposition: this.disposition_source,
            filter : {
              category : this.category,
              article_id : this.article_id,
            },
            page: this.page, 
            per_page: this.pageSize,
          }
        this.$httpSecured
          .post('/api/v2/warehouse/grading/create_grading_request',requestBody)
          .then(response => {
            if (response.data) {
              this.table_data = response.data.grading_items;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.article_id = '';
              this.category = '';
              this.filterDetails = false;
              this.selected = [];
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        } else if (this.active_tab == 'Grading Request Tracker'){
          const requestBody = {
          filter : {
            assigned_partner : this.assigned_partner.name,
            assigned_executive : this.assigned_executive,
            status : this.status,
          },
          page: this.page, 
          per_page: this.pageSize,
        }
        this.$httpSecured
          .post('/api/v2/warehouse/grading/grading_request_tracker',requestBody)
          .then(response => {
            if (response.data) {
              this.table_data = response.data.grading_requests;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.filterDetails = false;
              this.selected = [];
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        } else if (this.active_tab == 'Pending Manual Disposition'){
          const requestBody = {
          filter : {
            previous_grade : this.previous_grade,
            inward_grade : this.inward_grade,
            previous_disposition : this.previous_disposition,
          },
          page: this.page, 
          per_page: this.pageSize,
        }
        this.$httpSecured
          .post('/api/v2/warehouse/grading/pending_manual_disposition',requestBody)
          .then(response => {
            if (response.data) {
              this.table_data = response.data.grading_items;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.makeLoadingFalse();
              this.filterDetails = false
              this.selected = [];
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        } else if (this.active_tab == 'Pending Approval'){
          const requestBody = {
          filter : {
            previous_grade : this.previous_grade,
            inward_grade : this.inward_grade,
            previous_disposition : this.previous_disposition
          },
          page: this.page, 
          per_page: this.pageSize,
        }
        this.$httpSecured
          .post('/api/v2/warehouse/grading/pending_approval',requestBody)
          .then(response => {
            if (response.data) {
              this.table_data = response.data.grading_items;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.makeLoadingFalse();
              this.filterDetails = false
              this.selected = [];
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        }
      },
      makeLoadingFalse(){
        setTimeout(() => {
          this.loading = false;
        }, 1500);
      },
      //  pagination params
      getRequestParams(page, pageSize) {
        let params = {};
        if (page) {
          params["page"] = page;
        }
        if (pageSize) {
          params["size"] = pageSize;
        }
        return params;
      },
       // To handle the page change
      handlePageChange(value) {
        this.page = value;
        if (this.active_tab == 'Create Grading Request') {
            this.gradingRequest();
        } else if (this.active_tab == 'Grading Request Tracker') {
            this.gradingTracker();
        } else if (this.active_tab == 'Pending Manual Disposition') {
          this.pendingManual();
        } else if (this.active_tab == 'Pending Approval') {
          this.getPendingApproval();
        }
      },
      updateFilterItems(){
        this.article_id_items = [... new Set(this.table_data.map(item => item.article_id))];
        this.previous_grade_items = [... new Set(this.table_data.map(item => item.previous_grade))]
        this.inward_grade_items = [... new Set(this.table_data.map(item => item.inward_grade))]
        this.previous_disposition_items = [... new Set(this.table_data.map(item => item.previous_disposition))]
        this.status_items = [... new Set(this.table_data.map(x => x.status))]
      },
      //  To handle the page size change
      handlePageSizeChange(size) {
        this.pageSize = size;
        this.page = 1
        if (this.active_tab == 'Create Grading Request') {
            this.gradingRequest();
        } else if (this.active_tab == 'Grading Request Tracker') {
            this.gradingTracker();
        } else if (this.active_tab == 'Pending Manual Disposition') {
          this.pendingManual();
        } else if (this.active_tab == 'Pending Approval') {
          this.getPendingApproval();
        }
      },
      showAlert(alert_type, alert_message) {
        this.scrollToTop();
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
      },
      alertTimeOut() {
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      },
    }
  }
</script>
<style scoped>
  .filter_style{
    max-width: 300px;
    margin-bottom: 28px;
    min-height: 56px;
  }
  .search_style{
    max-width: 300px;
  }
  .v-dialog:has(.filter-repair){
    justify-content: right;
    align-items: baseline;
    top: var(--dialog-ypos);
  }
  .warningText{
    font-size: 20px;
  }
  @media (max-height: 1104px) {
    .PaddingItemPerPage{
        padding: 8px !important;
    }
  }
  @media (min-height: 1126px) {
    .PaddingItemPerPage{
        padding: 24px !important;
    }
  }
  .item-selected{
    margin-top: 23px;
    position: absolute;
    left: 41%;
  }
  .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 310px) !important;
  } 
  .filter_ui{
    margin-left: 30px !important;
    margin-top: 30px !important;
  }
</style>